// Shared CSV cell quoting for every hand-built CSV export.
// Every cell MUST go through this — formatNumber uses toLocaleString('en-IN'), which
// inserts thousands-separator commas (e.g. "1,235"), locale date strings carry a comma
// between date and time (e.g. "01/08/2026, 12:30:10 pm"), and free-text fields like image
// filenames routinely contain literal commas too. Any of these silently splits a row into
// extra columns if left unquoted.
export const csvCell = (value: unknown): string => {
    const str = value === null || value === undefined ? '' : String(value);
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};
